export default __webpack_public_path__ + "static/media/LDCapital-logo.5682f2cd.svg";